import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { ISelectOption } from '@widgets/multi-select';

export const fetch = async (): Promise<ISelectOption[]> => {
  return [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
  ];
};

export const useHostingStatusOptions = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
